module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/holes/panic-door-double/panicDoorDouble.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/holes/panic-door-double/panicDoorDouble.png
// module id = 482
// module chunks = 0